<div class="page-wrapper">
    <app-header-two></app-header-two>
    <main class="page-content">
        <router-outlet></router-outlet>
    </main>
    <app-footer-two></app-footer-two>
</div>